import React, { useState, useEffect } from 'react'
import { Panel, Row, Message } from 'rsuite'
import { useForm, Controller } from 'react-hook-form'
// import CheckboxRowForm from '../../components/forms/checkboxRowForm/CheckboxRowForm'
import SaveButton from '../../components/buttons/saveButton/SaveButton'
import { startLoading, doneLoading } from '../../utils/loading'
import { saveStrategyMuti, saveStrategyPercentMuti } from '../../redux/actions/strategic'
import CheckboxRowHaveSubForm from '../../components/forms/checkboxRowForm/CheckboxRowHaveSubForm'
//import { useParams } from 'react-router-dom'
import { useSelector } from 'react-redux'

import CheckboxRowHaveSubView from '../../components/forms/checkboxRowForm/CheckboxRowHaveSubView'
import EditButton from '../../components/buttons/editButton/EditButton'
import CancelButton from '../../components/buttons/cancelButton/CancelButton'

export default function StrategicMuti({ schema, projectIdList, onComplete = () => {} }) {
  const [isLoading, setIsLoading] = useState(false)
  const [isError, setIsError] = useState(false)
  const [isEditProportion, setIsEditProportion] = useState(false)
  const [percentError, setPercentError] = useState()
  // const dispatch = useDispatch()
  const { register, handleSubmit, errors, control, setValue, setError, clearErrors } = useForm()

  //const projectId = useSelector((state) => state.getParameter?.projectId)
  const projectId = sessionStorage.getItem('projectId')

  const handleSaveStategic = async (request) => {
    startLoading()
    setIsLoading(true)
    setIsError(false)
    try {
      await saveStrategyMuti(request)
      onComplete()
    } catch (e) {
      setIsError(true)
    }
    setIsLoading(false)
    doneLoading()
  }

  const handleSaveStategicPercent = async (request) => {
    startLoading()
    setIsLoading(true)
    setIsError(false)
    try {
      await saveStrategyPercentMuti(request)
      onComplete()
    } catch (e) {
      setIsError(true)
    }
    setIsLoading(false)
    doneLoading()
  }

  const onSubmit = (data) => {
    console.log('onSubmit', data)

    let optionSelected = data.selectedList.map((item) => {
      return { value: item, selected: true }
    })

    let reqestData = {
      //projectVersionIds: projectIdList,
      groupId: projectId,
      options: optionSelected,
      inputOther: {
        value: '',
        isSelected: false,
      },
    }

    handleSaveStategic(reqestData)
  }

  const onSubmitPercent = (data) => {
    console.log('onSubmit', data)
    setPercentError()

    let datas = []
    let totalPercent = 0

    for (const [key, value] of Object.entries(data)) {
      totalPercent += value

      datas.push({
        id: key.replace('percentage_', ''),
        value: value,
      })
    }

    if (totalPercent == 100) {
      let reqestData = {
        groupId: projectId,
        datas: datas,
      }
      // console.log('reqestData : ', JSON.stringify(reqestData))
      handleSaveStategicPercent(reqestData)
    } else {
      setPercentError('กรุณาระบุสัดส่วนให้เท่ากับ 100 สัดส่วนปัจจุบันคือ ' + totalPercent)
    }
  }

  return (
    <>
      <Panel shaded header={schema.header || schema.title} bordered collapsible defaultExpanded>
        {/* <CheckboxRowForm */}

        {isEditProportion ? (
          <CheckboxRowHaveSubView
            schema={schema}
            register={register}
            Controller={Controller}
            control={control}
            errors={errors}
            setValue={setValue}
            clearErrors={clearErrors}
            isInput={true}
            inputKey="percentage_"
          />
        ) : (
          <CheckboxRowHaveSubForm
            schema={schema}
            register={register}
            Controller={Controller}
            control={control}
            errors={errors}
            setValue={setValue}
            clearErrors={clearErrors}
          />
        )}

        <hr />
        {isError && (
          <Row style={{ marginBottom: 10 }}>
            <Message
              showIcon
              type="error"
              description={'เกิดข้อผิดพลาดในการบันทึก กรุณาลองใหม่อีกครั้งหรือติดต่อผู้ดูแลระบบ'}
            />
          </Row>
        )}

        {isEditProportion ? (
          <>
            {percentError && (
              <Row style={{ marginBottom: 10 }}>
                <Message showIcon type="error" description={percentError} />
              </Row>
            )}
            <SaveButton onClick={handleSubmit(onSubmitPercent)} disabled={isLoading}>
              {'บันทึกสัดส่วนยุทธศาสตร์ไปยังทุกโครงการ'}
            </SaveButton>
            <CancelButton onClick={() => setIsEditProportion(false)} disabled={isLoading}>
              {'ยกเลิกบันทึกสัดส่วนยุทธศาสตร์ไปยังทุกโครงการ'}
            </CancelButton>
          </>
        ) : (
          <>
            <SaveButton onClick={handleSubmit(onSubmit)} disabled={isLoading}>
              {'บันทึกยุทธศาสตร์ไปยังทุกโครงการ'}
            </SaveButton>
            <EditButton
              onClick={(e) => {
                setIsEditProportion(true)
              }}
              disabled={isLoading}
            >
              แก้ไขสัดส่วนยุทธศาสตร์
            </EditButton>
          </>
        )}
      </Panel>
    </>
  )
}
